import clsx from 'clsx';
import { type ReactNode, useId } from 'react';

import type { InputProps } from '../../ui/input';
import { Input } from '../../ui/input';
import * as styles from './share.css';
export type AuthInputProps = InputProps & {
  label?: string;
  error?: boolean;
  errorHint?: ReactNode;
  onEnter?: () => void;
};
export const AuthInput = ({
  label,
  error,
  errorHint,
  onEnter,
  className,
  id,
  'aria-describedby': describedBy,
  ...inputProps
}: AuthInputProps) => {
  const generatedId = useId();
  const inputId = id ?? generatedId;
  const errorId = `${inputId}-error`;
  const descriptionIds =
    [describedBy, error && errorHint ? errorId : undefined]
      .filter(Boolean)
      .join(' ') || undefined;
  return (
    <div
      className={clsx(styles.authInputWrapper, {
        'with-hint': !!errorHint,
      })}
    >
      {label ? <label htmlFor={inputId}>{label}</label> : null}
      <Input
        className={clsx(className)}
        size="extraLarge"
        status={error ? 'error' : 'default'}
        onEnter={onEnter}
        {...inputProps}
        id={inputId}
        aria-invalid={error || inputProps['aria-invalid'] || undefined}
        aria-describedby={descriptionIds}
      />
      <div
        id={errorId}
        role={error ? 'alert' : undefined}
        className={styles.authInputError}
        style={{ visibility: error ? 'visible' : 'hidden' }}
      >
        {errorHint}
      </div>
    </div>
  );
};
